var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"back-top-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"back-top",attrs:{"title":"返回顶部"},on:{"click":function($event){$event.stopPropagation();return _vm.scrollToTop.apply(null, arguments)}}},[_c('i',{staticClass:"el-icon-arrow-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }